<template>
  <div class="scroll-container">
    <v-list-item class="no-scroll">
      <v-list-item-title class="text-h6">{{ $t("ModelViewsTitle") }}</v-list-item-title>
      <v-list-item-action @click="setSideDrawer(null)" style="cursor: pointer">
        <img class="vis-icon" src="/img/toolbar/Close.svg" />
      </v-list-item-action>
    </v-list-item>
    <v-divider></v-divider>
    <v-list class="pt-0 scroll">
      <v-list-item v-if="headerNode" link @click="previousLevel">
        <v-list-item-action v-if="headerNode.previousPsId !== '-1'">
          <img class="vis-icon" src="/img/toolbar/Return.svg" />
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title v-text="headerNode.name"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item
        v-for="node in nodes"
        :key="node.psId"
        link
        :class="{
          'active-class': node.psId === selectedModelView && !node.children
        }"
        @click="node.children ? loadModelViewLevel(node.psId) : setSelection(node.psId)"
      >
        <v-list-item-action v-if="thumbnailData && thumbnailData[node.psId]">
          <img :src="thumbnailData[node.psId]" style="height: 100px; width: 100px; object-fit: contain" />
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title v-text="node.name" style="white-space: normal"></v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="node.children">
          <img class="vis-icon" src="/img/toolbar/ChevronOpen.svg" />
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  components: {},
  data: () => ({
    treeMap: new Map(),
    headerNode: null,
    nodes: [],
    previousPsId: "-1",
    selectedModelView: null,
    modelViewData: null,
    thumbnailData: null
  }),
  computed: {
    ...mapState(["touchScreenDevice", "triadPosition"]),
    ...mapGetters(["viewerManager", "snapshotManager", "pmiManager"])
  },
  mounted: function() {
    this.$root.$on("modelLoaded", this.loadNewModelViews);
    this.snapshotManager.enabled = true;
  },
  methods: {
    ...mapMutations(["setSideDrawer", "setTriadPosition"]),
    loadNewModelViews: function(psId) {
      this.treeMap = new Map();
      this.headerNode = null;
      this.nodes = [];
      this.previousPsId = "-1";
      this.selectedModelView = null;
      this.modelViewData = null;
      this.thumbnailData = {};
      this.buildTree(psId);
    },
    buildTree: function(psId) {
      var modelViewData = null;
      if (this.viewerManager.modelHasPmi(psId)) {
        modelViewData = this.pmiManager.getModelViewsStructureInfo();
      }
      if (modelViewData !== null) {
        modelViewData = modelViewData.children[0];
        this.treeMap.set(modelViewData.psId, modelViewData);
        this.loadChildren(modelViewData.children);
        this.loadModelViewLevel(modelViewData.psId);
      }
    },
    loadChildren: function(children) {
      for (var child of children) {
        this.treeMap.set(child.psId, child);
        if (child.children) {
          this.loadChildren(child.children);
        }
      }
    },
    loadModelViewLevel: function(psId) {
      if (this.headerNode) {
        this.previousPsId = this.headerNode.psId;
      }
      this.headerNode = this.treeMap.get(psId);
      this.headerNode.previousPsId = this.previousPsId;
      this.nodes = this.headerNode.children;
    },
    previousLevel: function() {
      if (this.headerNode.previousPsId !== "-1") {
        this.headerNode = this.treeMap.get(this.headerNode.previousPsId);
        this.nodes = this.headerNode.children;
      }
    },
    setSelection: function(psId) {
      if (this.selectedModelView !== null) {
        this.pmiManager.setModelViewActive(this.selectedModelView, false, () => {
          if (this.selectedModelView !== psId) {
            this.selectedModelView = psId;
            this.pmiManager.setModelViewActive(psId, true, () => {
              this.takeModelViewSnapshot(psId);
            });
            this.setSideDrawer(null);
          } else {
            this.selectedModelView = null;
          }
        });
      } else {
        this.selectedModelView = psId;
        this.pmiManager.setModelViewActive(psId, true, () => {
          this.takeModelViewSnapshot(psId);
        });
        this.setSideDrawer(null);
      }
    },
    takeModelViewSnapshot(psId) {
      var originalTriadPosition = this.triadPosition;
      this.setTriadPosition("notVisible");
      this.$nextTick(() => {
        this.snapshotManager.createSnapshotPNG(
          snapshot => {
            if (snapshot) {
              this.$set(this.thumbnailData, psId, snapshot);
            }
            this.setTriadPosition(originalTriadPosition);
          },
          {
            width: 100,
            height: 100,
            showOriginal: true
          }
        );
      });
    }
  }
};
</script>

<style scoped>
.active-class {
  background-color: rgb(61, 133, 164);
}
</style>
